import React from "react";

export function Pill({ children, tone = "teal", className = "" }) {
    const tones = {
        teal: "bg-klareet-T/15 text-klareet-T2 border-klareet-T/30",
        amber: "bg-klareet-AMBER/10 text-klareet-AMBER border-klareet-AMBER/30",
        mut: "bg-white/5 text-klareet-MUT border-klareet-bor",
    };
    return (
        <span
            className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border text-xs font-medium tracking-wide uppercase ${tones[tone]} ${className}`}
        >
            {children}
        </span>
    );
}
